// Scan prep instructions — step 3 of post-payment flow (UI only until Chunk 3).

import React from 'react';
import {
  ADHOC_INSTRUCTIONS_CTA,
  ADHOC_INSTRUCTIONS_DURATION_LABEL,
  ADHOC_INSTRUCTIONS_FOOTNOTE,
  ADHOC_INSTRUCTIONS_LEDE,
  ADHOC_INSTRUCTIONS_STEPS,
  ADHOC_INSTRUCTIONS_TITLE,
} from '../../content/adhocScanInstructions';
import AdhocFlowLayout from './AdhocFlowLayout';

interface AdhocInstructionsStageProps {
  onContinue: () => void;
  continuing?: boolean;
}

const AdhocInstructionsStage: React.FC<AdhocInstructionsStageProps> = ({
  onContinue,
  continuing = false,
}) => (
  <AdhocFlowLayout currentStep={3} stepLabel="Before you scan">
    <div className="flow-instructions">
      <div className="flow-instructions-hero">
        <div className="flow-ring-wrap" aria-hidden="true">
          <div className="flow-ring-pulse" />
          <div className="flow-ring-pulse delay" />
          <div className="flow-ring-core">
            <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M23 7l-7 5 7 5V7z" />
              <rect x="1" y="5" width="15" height="14" rx="2" />
            </svg>
          </div>
        </div>

        <h1 className="flow-instructions-title">{ADHOC_INSTRUCTIONS_TITLE}</h1>
        <p className="flow-instructions-lede">{ADHOC_INSTRUCTIONS_LEDE}</p>
        <div className="flow-timer-chip">
          <span className="flow-timer-dot" />
          {ADHOC_INSTRUCTIONS_DURATION_LABEL}
        </div>
      </div>

      <div className="flow-instructions-scroll">
        <ol className="flow-prep-steps">
          {ADHOC_INSTRUCTIONS_STEPS.map((step) => (
            <li key={step.num} className="flow-prep-step">
              <span className="flow-prep-num">{step.num}</span>
              <div className="flow-prep-text">
                <h3>{step.title}</h3>
                <p>{step.body}</p>
              </div>
            </li>
          ))}
        </ol>

        <p className="flow-instructions-footnote">{ADHOC_INSTRUCTIONS_FOOTNOTE}</p>
      </div>

      <div className="flow-cta-row">
        <button
          type="button"
          className="flow-primary"
          disabled={continuing}
          onClick={onContinue}
        >
          {continuing ? 'Opening camera…' : ADHOC_INSTRUCTIONS_CTA}
        </button>
      </div>
    </div>
  </AdhocFlowLayout>
);

export default AdhocInstructionsStage;
